import {
  RECONSIDERATION_PENDING_BY_VOLUME_FAILURE,
  RECONSIDERATION_PENDING_BY_VOLUME_SUCCESS,
  RECONSIDERATION_PENDING_BY_VOLUME_LOADING,
  RECONSIDERATION_PENDING_BY_VOLUME_REQUEST,
  RECONSIDERATION_AVERAGE_TURNAROUND_TIME_FAILURE,
  RECONSIDERATION_AVERAGE_TURNAROUND_TIME_SUCCESS,
  RECONSIDERATION_AVERAGE_TURNAROUND_TIME_LOADING,
  RECONSIDERATION_AVERAGE_TURNAROUND_TIME_REQUEST,
  RECONSIDERATION_OUTCOME_VOLUME_DATA_REQUEST,
  RECONSIDERATION_OUTCOME_SUBMISSION_DATA_FAILURE,
RECONSIDERATION_DETAILS_REQUEST,
RECONSIDERATION_OUTCOME_SUBMISSION_DATA_REQUEST,
RECONSIDERATIONS_DETAILS_DATA_REQUEST
} from '../actionTypes';

export const fetchReconsiderationVolumeDataRequest = (payload: any, highVolumeTinFlag?: boolean) => ({
  type: RECONSIDERATION_PENDING_BY_VOLUME_REQUEST,
  payload,
  highVolumeTinFlag,
});

export const fetchReconsiderationVolumeDataSuccess = (payload: any) => ({
  type: RECONSIDERATION_PENDING_BY_VOLUME_SUCCESS,
  payload,
});
export const fetchReconsiderationVolumeDataError = (payload: any) => ({
  type: RECONSIDERATION_PENDING_BY_VOLUME_FAILURE,
  payload,
});
export const fetchReconsiderationVolumeDataLoading = (payload: any) => ({
  type: RECONSIDERATION_PENDING_BY_VOLUME_LOADING,
  payload,
});

export const fetchReconsiderationAverageDataRequest = (payload: any, highVolumeTinFlag?: boolean) => ({
  type: RECONSIDERATION_AVERAGE_TURNAROUND_TIME_REQUEST,
  payload,
  highVolumeTinFlag,
});

export const fetchReconsiderationAverageDataSuccess = (payload: any) => ({
  type: RECONSIDERATION_AVERAGE_TURNAROUND_TIME_SUCCESS,
  payload,
});
export const fetchReconsiderationAverageDataError = (payload: any) => ({
  type: RECONSIDERATION_AVERAGE_TURNAROUND_TIME_FAILURE,
  payload,
});
export const fetchReconsiderationAverageDataLoading = (payload: any) => ({
    type: RECONSIDERATION_AVERAGE_TURNAROUND_TIME_LOADING,
    payload
});

export const fetchReconsiderationsDetailsDataRequest = (payload: any, key: string) => ({
    type: RECONSIDERATIONS_DETAILS_DATA_REQUEST,
    key,
    payload,
});

export const fetchReconsiderationOutcomeReasonsData = (payload: any) => ({
  type: RECONSIDERATION_OUTCOME_VOLUME_DATA_REQUEST,
  payload,
});

export const fetchReconsiderationSubmissionReasonsData = (payload: any) => ({
  type:RECONSIDERATION_OUTCOME_SUBMISSION_DATA_REQUEST,
  payload,
});

export const fetchReconsiderationDetails = (payload: any) => ({
  type: RECONSIDERATION_DETAILS_REQUEST,
  payload,
});
